export function generalAction(type, result, rest) {
  if (typeof result === 'undefined' || result === null) {
    return { type, ...rest };
  }

  return { type, result, ...rest };
}

export function createAction(type, payload = {}, parent = null, showNotification = true) {
  return {
    type,
    payload,
    error: payload instanceof Error,
    parent,
    showNotification,
  };
}
